import { render, staticRenderFns } from "./HolidaysPage.vue?vue&type=template&id=afbb8d4c&scoped=true"
import script from "./HolidaysPage.vue?vue&type=script&lang=js"
export * from "./HolidaysPage.vue?vue&type=script&lang=js"
import style0 from "./HolidaysPage.vue?vue&type=style&index=0&id=afbb8d4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbb8d4c",
  null
  
)

export default component.exports